var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offlineConfirmed)?_c('div',[_c('h1',{class:_vm.$style.title},[_vm._v(" A página atingiu o tempo limite durante o carregamento. Tem certeza de que ainda está conectado a a Internet? ")])]):_c('div',{staticClass:"loading"},[_c('a-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }